interface Crop {
  readonly crop_name: string;
}
export function sortCropsByName<T extends Crop>(crops: readonly T[]): T[] {
  const sortedCrops = [...crops];
  sortedCrops.sort((a, b) => compareCropsByName(a.crop_name, b.crop_name));

  return sortedCrops;
}

export function compareCropsByName(a: string, b: string): number {
  const aName = a.toLowerCase();
  const bName = b.toLowerCase();
  if (aName < bName) {
    return -1;
  }
  if (aName > bName) {
    return 1;
  }
  return 0;
}
